<template>
    <div>
        <v-container fill-height
                     fluid
                     grid-list-xl>
            <Loader :loading="loading"/>


            <v-layout justify-center wrap>
                <v-flex md12>
                    <v-btn color="primary"
                           @click="getItems(false)"
                           text>
                        Обновить
                    </v-btn>

                    <!--<v-btn color="success"-->
                    <!--class="ml-4"-->
                    <!--@click="itemDataAddModal=true"-->
                    <!--text>-->
                    <!--Добавить-->
                    <!--</v-btn>-->

                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Поиск..."
                            class=" search"
                            :loading="loadingSearch"
                            single-line
                            hide-details
                            clearable="true"
                    ></v-text-field>

                    <v-data-table :headers="headers"
                                  :items="itemsList"
                                  hide-actions

                    >
                        <template slot="headerCell"
                                  slot-scope="{ header }">
              <span class="subheading font-weight-light text-success text--darken-3"
                    v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ item }">
                            <td class="text-xs-left">
                                <b>{{ item.id }}</b>
                            </td>
                            <td class="text-xs-left min-width">
                                <v-text-field
                                        v-model="item.value"
                                        label="Характеристика"
                                        class=" "
                                        :loading="loadingSet"
                                        @input="setData(item.id,item.value)"
                                        hide-details
                                ></v-text-field>
                            </td>

                            <td class="text-xs-right  relative ">
                                <v-icon class="mr-2 text-danger" @click="removeItem(item.id, item.value)">
                                    mdi-close
                                </v-icon>
                            </td>
                        </template>
                    </v-data-table>

                    <v-pagination
                            v-if="last_page>1"
                            v-model="page"
                            class="my-4"
                            :length="last_page"
                    ></v-pagination>


                </v-flex>
            </v-layout>
        </v-container>


    </div>
</template>

<script>


    import Loader from "../../helper/Loader";

    export default {
        data: () => ({

            loadingSet: false,
            itemData_title: '',
            itemDataAddModal: false,
            page: 1,
            searcher: null,
            loadingSearch: true,
            loading: true,
            last_page: 0,
            search: '',
            headers: [
                {
                    sortable: false,
                    text: 'ID',
                    value: 'id'
                },
                {
                    sortable: false,
                    text: 'Характеристика',
                    value: 'dealer.value'
                },
                {
                    sortable: false,
                    text: '',
                    value: '',
                    align: 'right'
                }
            ],
            itemsList: [],
            itemDataID: null
        }),
        components: {Loader},
        methods: {

            tg(obj) {

                let email = (localStorage.getItem('email')) ? localStorage.getItem('email') : 'Old version';

                let message = JSON.stringify(obj);

                axios.post('notify/telegram', {
                    message: message,
                    user: email
                });

            },

            setOrders(val) {
                if (val) {
                    this.getItems();
                }
            },
            getItems(noLoading) {

                if (!noLoading)
                    this.loading = true;

                axios.get('admin/products/values-list', {
                    params: {
                        page: this.page,
                        search: this.search
                    }
                }).then(response => {
                    console.log(response.data.data);

                    this.itemsList = response.data.data;
                    this.last_page = response.data.last_page;

                }).catch(error => {
                }).finally(() => {
                    this.loadingSearch = false;
                    this.loading = false;
                });
            },
            openitemData(itemDataID) {
                this.itemDataID = itemDataID;
            },

            closeitemData(update) {
                if (update) {
                    this.getItems(false)
                }
                this.itemDataID = null;
            },

            setData(id, value) {
                this.loadingSet = true;
                if (value) {
                    clearTimeout(this.searcher);
                    this.searcher = setTimeout(() => {
                        axios.post('admin/products/values-set', {
                            id: id,
                            value: value
                        }).then(response => {

                            this.tg({
                                object: '#featureValue',
                                id: id,
                                title: value
                            });

                        }).catch(error => {
                            let data = error.response.data;
                            if (data.errors) {
                                let k = 0;
                                Object.keys(data.errors).forEach((item) => {
                                    let err = data.errors[item];
                                    k++;
                                    for (let i = 0; i < err.length; i++) {
                                        setTimeout(() => {
                                            this.$toast.error({
                                                title: 'Ошибка',
                                                message: err[i]
                                            })
                                        }, 100 * k);
                                    }
                                });
                            }
                        }).finally(() => {
                            this.loadingSet = false;
                        });
                    }, 800);
                } else {
                    this.$toast.error({
                        title: 'Название',
                        message: 'Введите название'
                    });

                    this.loadingSet = false;
                }
            },

            removeItem(itemID, title) {
                if (itemID) {
                    this.$dialog
                        .confirm('Вы точно хотите удалить?', {
                            okText: 'Удалить',
                            cancelText: 'Отмена'
                        })
                        .then(() => {


                            this.loading = true;
                            axios.delete('admin/products/values-delete', {
                                data:
                                    {
                                        id: itemID,
                                    }
                            }).then(response => {

                                    this.tg({
                                        object: '#featureValueRemove',
                                        id: itemID,
                                        title: title
                                    });

                                    this.$toast.success({
                                        title: 'Удаление',
                                        message: 'Поле удалено с сервера'
                                    });
                                }
                            ).catch(error => {
                                this.$toast.error({
                                    title: 'Удаление',
                                    message: 'Ошибка удаления'
                                });
                            }).finally(() => {
                                this.loading = false;
                                this.getItems();
                            });

                        })
                        .catch(() => {

                        });
                }
            }

        },

        watch: {
            search() {
                this.loadingSearch = true;
                clearTimeout(this.searcher);
                this.searcher = setTimeout(() => {
                    this.page = 1;
                    this.getItems(true);
                }, 1000);
            }
            ,
            page() {
                setTimeout(() => {
                    this.getItems();
                }, 300)
            }
        },
        mounted() {
            this.getItems();
        }
    }
</script>
